import React from 'react';
import { Route, Routes as AppRoutes } from 'react-router-dom';
import VendorIntakeForm from './VendorIntakeForm/VendorIntakeForm';
import ExternalVendorReview from './ExternalVendorReview/ExternalVendorReview';
import PageNotFound from './PageNotFound';

const Routes = () => (
  <AppRoutes>
    <Route exact={true} path='/vendorintake' element={<VendorIntakeForm/>} />
    <Route exact={true} path='/vendorinformation/:recId' element={<ExternalVendorReview/>} />    
    <Route exact={false} path='*' element={<PageNotFound/>} />
  </AppRoutes>
);

export default Routes;
